import WithRender from "../../templates/base/uploadPreflight.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getSelectionId",
      "getShowPreviewInUpload",
      "getIsPackingEnabled",
      "getIsPreflighPitstop",
      "getPitstopFileIsLoading",
      "getPitstopFileStatusResponse",
      "getTimer",
      "getUrl",
      "getSelectedOption",
      "getPreflightData",
      "getUploadForProductPart",
      "getFileParameters"
    ]),
    getPreviewData: function () {
      return {
        code: this.propsData.code,
        class: this.getClassName + "PreviewContainer"
      };
    },
    getActionsData: function () {
      return {
        code: this.propsData.code,
        class: this.getClassName + "ActionsContainer"
      };
    },
    showPitstopLoading: function () {
      if (this.getIsPreflighPitstop || this.getAttribute("uploadedFileHash")) {
        return this.getPitstopFileIsLoading(this.getAttribute("uploadedFile"));
      }
      return false;
    },
    showPitstopInfo: function () {
      if (this.getIsPreflighPitstop || this.getAttribute("uploadedFileHash")) {
        var fileInfo = this.getPitstopFileStatusResponse(
          this.getAttribute("uploadedFile")
        );
        if (!fileInfo) {
          return false;
        }

        if (fileInfo.status == "REQUEST_ERROR") {
          return [
            {
              isStatus: true,
              label: i18n.t("Preflight Status"),
              message: {
                [i18n.t("Status") + ":"]: i18n.t("Request error")
              }
            }
          ];
        }

        var info = [];
        // status
        info.push({
          isStatus: true,
          label: i18n.t("Preflight Status"),
          message: {
            [i18n.t("Status") + ":"]: fileInfo.status,
            [i18n.t("Errors") + ":"]: fileInfo.data.Errors,
            [i18n.t("Fixes") + ":"]: fileInfo.data.Fixed_errors,
            [i18n.t("Warnings") + ":"]: fileInfo.data.Warnings
          }
        });

        var updatedPreflight = this.getPreflightData(this.propsData.code);
        if (Object.keys(updatedPreflight).length > 0) {
          for (var item in updatedPreflight) {
            info.push(updatedPreflight[item]);
          }
          return info;
        }

        // info
        var preflightInfo = {};
        var anyPP = Object.keys(fileInfo.preflight)[0];
        for (var key in fileInfo.preflight[anyPP]) {
          var obj = fileInfo.preflight[anyPP][key];
          if (obj && typeof obj == "object") {
            info.push(obj);
          } else {
            preflightInfo[key] = fileInfo.preflight[anyPP][key];
          }
        }

        if (fileInfo.status == "FINALIZED") {
          return info;
        }

        this.setPreflightInfo({
          code: this.propsData.code,
          preflightInfo,
          request_finalized: true,
          uploadedFile: this.getAttribute("uploadedFile")
        });
        return info;
      }
      return false;
    },
    preflightData: function () {
      return this.getPreflightData(this.propsData.code);
    }
  },
  methods: {
    ...mapActions(["setPreflightInfo"]),
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "useClassName"]
});
